'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lsamples_Persons$package$$anon$19$$anon$24$$anon$26(evaluator$30) {
  this.Lw = null;
  this.Lw = evaluator$30;
}
export { $c_Lsamples_Persons$package$$anon$19$$anon$24$$anon$26 as $c_Lsamples_Persons$package$$anon$19$$anon$24$$anon$26 };
$p = $c_Lsamples_Persons$package$$anon$19$$anon$24$$anon$26.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lsamples_Persons$package$$anon$19$$anon$24$$anon$26;
/** @constructor */
function $h_Lsamples_Persons$package$$anon$19$$anon$24$$anon$26() {
}
export { $h_Lsamples_Persons$package$$anon$19$$anon$24$$anon$26 as $h_Lsamples_Persons$package$$anon$19$$anon$24$$anon$26 };
$h_Lsamples_Persons$package$$anon$19$$anon$24$$anon$26.prototype = $p;
$p.b = (function() {
  return "<function0>";
});
$p.v = (function() {
  var v = this.Lw.h();
  return ($j_java$002elang$002e$002dObject.$isInt(v) ? new $j_java$002elang$002e$002dObject.$c_s_Some(v) : $j_java$002elang$002e$002dObject.$m_s_None$());
});
$p.h = (function() {
  return this.v();
});
var $d_Lsamples_Persons$package$$anon$19$$anon$24$$anon$26 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lsamples_Persons$package$$anon$19$$anon$24$$anon$26, "samples.Persons$package$$anon$19$$anon$24$$anon$26", ({
  pG: 1,
  d: 1,
  a: 1,
  f: 1
}));
export { $d_Lsamples_Persons$package$$anon$19$$anon$24$$anon$26 as $d_Lsamples_Persons$package$$anon$19$$anon$24$$anon$26 };
